import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  videoJwPushRequest: ['id', 'jwPushParams'],
  videoJwPushSuccess: ['jwPushData'],
  videoJwPushFailure: ['jwPushError'],
})

export const VideoIntegrationTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  jwPushData: {},
  jwPushFetching: null,
  jwPushError: null,
})

/* ------------- Reducers ------------- */

export const jwPushRequest = (state) =>
  state.merge({ jwPushFetching: true, jwPushError: null })

export const jwPushSuccess = (state, { jwPushData }) =>
  state.merge({ jwPushFetching: false, jwPushData })

export const jwPushFailure = (state, { jwPushError }) => {
  return state.merge({ jwPushFetching: false, jwPushError })
}

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.VIDEO_JW_PUSH_REQUEST]: jwPushRequest,
  [Types.VIDEO_JW_PUSH_SUCCESS]: jwPushSuccess,
  [Types.VIDEO_JW_PUSH_FAILURE]: jwPushFailure,
})



// WEBPACK FOOTER //
// ./src/Redux/VideoIntegrationRedux.js